import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarChecked = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 44,
	height: 42,
	viewBox: "0 0 44 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M22 5L26.0413 17.4377H39.119L28.5389 25.1246L32.5801 37.5623L22 29.8754L11.4199 37.5623L15.4611 25.1246L4.88098 17.4377H17.9587L22 5Z",
		fill: "#B9F833",
		stroke: "#B9F833",
		strokeWidth: 3
	})
});
export default SvgStarChecked;
